module.exports = __webpack_public_path__ + "static/img/cZcS3FVg.2f0c0d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/cZcS3FVg.jpg
// module id = dIJ/
// module chunks = 7